import React from 'react';

function Patti_home() {
  return (
    <div className="bg-gradient-to-r from-[#D4AF37] via-[#F5E6C5] to-[#D4AF37] text-[#050608] text-xs font-bold tracking-[0.15em] uppercase overflow-hidden whitespace-nowrap h-full flex items-center">
      <style>{`
        .animate-marquee-top {
          display: inline-flex;
          animation: marqueeTop 25s linear infinite;
          align-items: center;
        }
        @keyframes marqueeTop {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
      <div className="animate-marquee-top flex gap-12 sm:gap-24">
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
        <span>CUSTOM TAILORED → PERFECT FIT → HIGH QUALITY MATERIAL → FAST DELIVERY →</span>
      </div>
    </div>
  );
}

export default Patti_home;
